/* GoogleSignInButton — kicks off the Emergent-managed Google OAuth flow.
 * No client_id / secret needed — Emergent handles the Google side entirely.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. The redirect must be derived dynamically from
 * window.location.origin so it works in both preview and production.
 */
import React from 'react';

export default function GoogleSignInButton({ label = 'Fortsätt med Google', testId = 'google-signin-btn' }) {
  const startGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={startGoogle}
      className="neo-btn w-full py-3 bg-white border-2 border-black flex items-center justify-center gap-2 font-bold"
      data-testid={testId}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.24 1.4-1.66 4.1-5.5 4.1-3.31 0-6-2.73-6-6.1s2.69-6.1 6-6.1c1.88 0 3.14.79 3.87 1.48l2.63-2.53C16.85 3.32 14.63 2.4 12 2.4 6.75 2.4 2.5 6.65 2.5 12s4.25 9.6 9.5 9.6c5.48 0 9.11-3.85 9.11-9.28 0-.62-.07-1.1-.16-1.57H12z"/>
      </svg>
      <span>{label}</span>
    </button>
  );
}
